var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgParallelGenerationsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 2.1875H3.9375C3.70544 2.1875 3.48288 2.27969 3.31878 2.44378C3.15469 2.60788 3.0625 2.83044 3.0625 3.0625V3.9375H2.1875C1.95544 3.9375 1.73288 4.02969 1.56878 4.19378C1.40469 4.35788 1.3125 4.58044 1.3125 4.8125V10.9375C1.3125 11.1696 1.40469 11.3921 1.56878 11.5562C1.73288 11.7203 1.95544 11.8125 2.1875 11.8125H10.0625C10.2946 11.8125 10.5171 11.7203 10.6812 11.5562C10.8453 11.3921 10.9375 11.1696 10.9375 10.9375V10.0625H11.8125C12.0446 10.0625 12.2671 9.97031 12.4312 9.80622C12.5953 9.64212 12.6875 9.41956 12.6875 9.1875V3.0625C12.6875 2.83044 12.5953 2.60788 12.4312 2.44378C12.2671 2.27969 12.0446 2.1875 11.8125 2.1875ZM10.0625 4.8125V5.6875H2.1875V4.8125H10.0625ZM10.0625 10.9375H2.1875V6.5625H10.0625V10.9375ZM11.8125 9.1875H10.9375V4.8125C10.9375 4.58044 10.8453 4.35788 10.6812 4.19378C10.5171 4.02969 10.2946 3.9375 10.0625 3.9375H3.9375V3.0625H11.8125V9.1875Z",
    fill: "#D3D7D9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgParallelGenerationsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/parallel-generations-icon.c0542d3317ac4066bd4c25c476fded4c.svg";